export const nakamigosNFTs = [

    {
      "id": "nakamigos-19995",
      "name": "Nakamigos #19995",
      "image": "https://ipfs.io/ipfs/QmbJpQiRwJmCk9T1j14st1NKdeyp2tvynbArnLmKRm556G",
      "price": "0.85"
    },
    {
      "id": "nakamigos-19994",
      "name": "Nakamigos #19994",
      "image": "https://ipfs.io/ipfs/Qmd97nfbFu3AkosMSNytHAXHBdu4khtXcxz16Gjx5YufZ9",
      "price": "0.32"
    },
    {
      "id": "nakamigos-19991",
      "name": "Nakamigos #19991",
      "image": "https://ipfs.io/ipfs/QmR7TZhVtP1ez7A7MN7kpycC5MwbEQqW7VbHKabXbbbnb1",
      "price": "1.15"
    },
    {
      "id": "nakamigos-19992",
      "name": "Nakamigos #19992",
      "image": "https://ipfs.io/ipfs/QmXpgCGQh8CjLkR6vQKFjC8Toy7dD3yLfWUhYj4hm1cAUU",
      "price": "0.67"
    },
    {
      "id": "nakamigos-19987",
      "name": "Nakamigos #19987",
      "image": "https://ipfs.io/ipfs/QmXLENu2SXEVJLNJMJcBfJ4bzG53KvtKAR4RDTgRj6DJV2",
      "price": "0.23"
    },
    {
      "id": "nakamigos-19983",
      "name": "Nakamigos #19983",
      "image": "https://ipfs.io/ipfs/QmW5ZX8P8cv9Fv38xdd64rhAKs67pJ4D1MyeLEYDHC4niZ",
      "price": "0.91"
    },
    {
      "id": "nakamigos-19980",
      "name": "Nakamigos #19980",
      "image": "https://ipfs.io/ipfs/QmR9z7hvVkVXBRVwvZXvmEGDqHFmNeGYpMWX2WeBGrta37",
      "price": "0.45"
    },
    {
      "id": "nakamigos-19979",
      "name": "Nakamigos #19979",
      "image": "https://ipfs.io/ipfs/QmRifEmwjUCypdio1mNnPuar5BpEEWoE2BLs4oCfSVr6KH",
      "price": "1.08"
    },
    {
      "id": "nakamigos-19978",
      "name": "Nakamigos #19978",
      "image": "https://ipfs.io/ipfs/QmVcuCnYiHLTv8zRhiJNwke4ucWToz4CGdC8V67axtZJST",
      "price": "0.73"
    },
    {
      "id": "nakamigos-19976",
      "name": "Nakamigos #19976",
      "image": "https://ipfs.io/ipfs/QmYkCsUX18HgbguyocagLqRDJEdG8EMzju8nztMshgGvwc",
      "price": "0.28"
    },
    {
      "id": "nakamigos-19953",
      "name": "Nakamigos #19953",
      "image": "https://ipfs.io/ipfs/QmRoMq8ZpCoSVteeMQizstdtXjfFujujCQvsp31BXQuyXp",
      "price": "0.95"
    },
    {
      "id": "nakamigos-19972",
      "name": "Nakamigos #19972",
      "image": "https://ipfs.io/ipfs/QmayNRJ2tr66Mb4u3Wth4xHHZWAZDQeyWpxSHibTdJFMNj",
      "price": "0.52"
    },
    {
      "id": "nakamigos-19964",
      "name": "Nakamigos #19964",
      "image": "https://ipfs.io/ipfs/QmetSebn1FQmN78djbCAns9xPBnbQHB2cLydBRfd1spwB4",
      "price": "1.18"
    },
    {
      "id": "nakamigos-19950",
      "name": "Nakamigos #19950",
      "image": "https://ipfs.io/ipfs/Qmdx12oogWKYH4qDqRPSGTNyQs9X7iAG78qHKG5hDmE44m",
      "price": "0.78"
    },
    {
      "id": "nakamigos-19971",
      "name": "Nakamigos #19971",
      "image": "https://ipfs.io/ipfs/QmXxJbLfApg3F39onaZcWbWGrsx1hJSPBzQoXQHau1bS5f",
      "price": "0.34"
    },
    {
      "id": "nakamigos-19949",
      "name": "Nakamigos #19949",
      "image": "https://ipfs.io/ipfs/QmdtE77MSx8Pbmkn6RY83kNa3eu8qdswdU2a6DxNkZMhVZ",
      "price": "1.02"
    },
    {
      "id": "nakamigos-19970",
      "name": "Nakamigos #19970",
      "image": "https://ipfs.io/ipfs/Qme5zJKVW5whhV7b8sSuDLcSDMZEVc3hjU3YFeQcQyGEwi",
      "price": "0.56"
    },
    {
      "id": "nakamigos-19948",
      "name": "Nakamigos #19948",
      "image": "https://ipfs.io/ipfs/QmSDmuazj61tPgWX2p25y2Y7EH3VQvCjtNbca4QHG6T8SY",
      "price": "1.12"
    },
    {
      "id": "nakamigos-19961",
      "name": "Nakamigos #19961",
      "image": "https://ipfs.io/ipfs/QmQyiyhcepdU3s7npj34odcHuRKGNJuGgpJFY525n2jsYv",
      "price": "0.82"
    },
    {
      "id": "nakamigos-19968",
      "name": "Nakamigos #19968",
      "image": "https://ipfs.io/ipfs/QmZMf3SY1UcRcSdR9MeexVWTopikPyJxbRZYJsq3gssRxz",
      "price": "0.39"
    },
    {
      "id": "nakamigos-19960",
      "name": "Nakamigos #19960",
      "image": "https://ipfs.io/ipfs/QmTLvxdoYAcgsqZxrNHLeQV4UG3R4KmVzfF29jt9v5Nq5V",
      "price": "0.98"
    },
    {
      "id": "nakamigos-19946",
      "name": "Nakamigos #19946",
      "image": "https://ipfs.io/ipfs/QmammMuwqmC81fBTWms1CpuypRnE61HYEk3hqSH5NbtjD2",
      "price": "0.61"
    },
    {
      "id": "nakamigos-19967",
      "name": "Nakamigos #19967",
      "image": "https://ipfs.io/ipfs/Qmb4WhXPSD7WqkGBsYqQm8Nj7NHDcgReBECDRRJ3vivyXH",
      "price": "1.19"
    },
    {
      "id": "nakamigos-19958",
      "name": "Nakamigos #19958",
      "image": "https://ipfs.io/ipfs/QmVRwVwnTiZuwHhpFj2m25PBpEdsRBhFVo8LdA5KBa3iko",
      "price": "0.87"
    },
    {
      "id": "nakamigos-19956",
      "name": "Nakamigos #19956",
      "image": "https://ipfs.io/ipfs/QmehiR2xtc6rtN3j1Bn9VAGgPXa3aPrECDvNS4UQsh3jBH",
      "price": "0.43"
    },
    {
      "id": "nakamigos-19935",
      "name": "Nakamigos #19935",
      "image": "https://ipfs.io/ipfs/QmY8dwqJ4nGWnyB1iap9oZEh9apY3CfAy4KLzfttCdPyJj",
      "price": "1.05"
    },
    {
      "id": "nakamigos-19934",
      "name": "Nakamigos #19934",
      "image": "https://ipfs.io/ipfs/QmeRjSSQF3jq5USWNri3ZwPhTpNxT6QQ5s4qKgvE7g7HCU",
      "price": "0.69"
    },
    {
      "id": "nakamigos-19905",
      "name": "Nakamigos #19905",
      "image": "https://ipfs.io/ipfs/QmYU34CPCagucig3hcJKxtDa2R9EupcXvZMoKFvVUGb2tN",
      "price": "0.25"
    },
    {
      "id": "nakamigos-19904",
      "name": "Nakamigos #19904",
      "image": "https://ipfs.io/ipfs/Qmb8nZNLQikXSEoCwpvenm8vXay4P5nbAKNX4fnxYrnR9x",
      "price": "0.93"
    },
    {
      "id": "nakamigos-19930",
      "name": "Nakamigos #19930",
      "image": "https://ipfs.io/ipfs/QmXGGt7y1LmQVFSDzeRrXGp5QXfVSFsVMEuvD5hSariWr4",
      "price": "0.48"
    },
    {
      "id": "nakamigos-19922",
      "name": "Nakamigos #19922",
      "image": "https://ipfs.io/ipfs/QmahWJxPco7Ao9MhYBC58ztwE6cHsjmLskHZoH2Uhyws62",
      "price": "1.11"
    },
    {
      "id": "nakamigos-19915",
      "name": "Nakamigos #19915",
      "image": "https://ipfs.io/ipfs/QmdhqGMZuRM3h1ubEwierWm9DmctHgtC4wjYdcdTPi6AZU",
      "price": "0.75"
    },
    {
      "id": "nakamigos-19921",
      "name": "Nakamigos #19921",
      "image": "https://ipfs.io/ipfs/QmV7srsSDWCaDM4VrAPJDtVCzgY4HYGxwjNNC6HU7gWriS",
      "price": "0.31"
    },
    {
      "id": "nakamigos-19920",
      "name": "Nakamigos #19920",
      "image": "https://ipfs.io/ipfs/QmS65XMSRLzbqHSkFv5aRWTjuuLfYdECVtKWNqTkiACPo1",
      "price": "0.97"
    },
    {
      "id": "nakamigos-19927",
      "name": "Nakamigos #19927",
      "image": "https://ipfs.io/ipfs/QmZyPQuRpVYAJe9HYTMnUQAmet5qPHCM4SuTP9anjSjzrF",
      "price": "0.54"
    },
    {
      "id": "nakamigos-19901",
      "name": "Nakamigos #19901",
      "image": "https://ipfs.io/ipfs/QmRu7EiXgerrV7anjLxrZUTX6j16E4WM3pPqyYVPUUHdzL",
      "price": "1.16"
    },
    {
      "id": "nakamigos-19919",
      "name": "Nakamigos #19919",
      "image": "https://ipfs.io/ipfs/QmRAyTHwK7wC7UXH7PMyByjg1XXnmcRDzAeJp5ST5ANxzq",
      "price": "0.83"
    },
    {
      "id": "nakamigos-19926",
      "name": "Nakamigos #19926",
      "image": "https://ipfs.io/ipfs/QmeQkbp9uHvU8V6WgEdLg65vtmhiwz8E5ahjK1HV3Va58a",
      "price": "0.41"
    },
    {
      "id": "nakamigos-19899",
      "name": "Nakamigos #19899",
      "image": "https://ipfs.io/ipfs/QmQ9icFw9YXmCLcSaAwMTEBgTFwCcj9yct2zacn2kuunqQ",
      "price": "1.04"
    },
    {
      "id": "nakamigos-19912",
      "name": "Nakamigos #19912",
      "image": "https://ipfs.io/ipfs/QmfQBnPvUqkVc5igiY6uSXM5TdFKSTQ1LxEA5F1Uycik5P",
      "price": "0.63"
    },
    {
      "id": "nakamigos-19917",
      "name": "Nakamigos #19917",
      "image": "https://ipfs.io/ipfs/QmZzP55XhrkDTb5GuPxoYU7NjYAmxBkFeaGmEHZeH6BHdt",
      "price": "0.22"
    },
    {
      "id": "nakamigos-19896",
      "name": "Nakamigos #19896",
      "image": "https://ipfs.io/ipfs/QmdsnmyAqLYZSPtVkUiQs15911md79XVhKbovp9wAEQzNA",
      "price": "0.89"
    },
    {
      "id": "nakamigos-19909",
      "name": "Nakamigos #19909",
      "image": "https://ipfs.io/ipfs/QmRiY9gKcaJho3sHUq33r7KLboYyNbHBkMXbc2hbw2Fom8",
      "price": "0.46"
    },
    {
      "id": "nakamigos-19908",
      "name": "Nakamigos #19908",
      "image": "https://ipfs.io/ipfs/QmYMeiiwggAihASE6KbXTZCP2bqsTMk9yhSwQVT3XcEyju",
      "price": "1.13"
    },
    {
      "id": "nakamigos-19906",
      "name": "Nakamigos #19906",
      "image": "https://ipfs.io/ipfs/QmeeAvyQApGHNgKAdjwsigbTfMo8cjiUnJzK2qdKLbRfhg",
      "price": "0.77"
    },
    {
      "id": "nakamigos-19875",
      "name": "Nakamigos #19875",
      "image": "https://ipfs.io/ipfs/QmfXqwur3vhsG6xXQJbfvFT7SNr5L2DTro35M6FxXfw9rR",
      "price": "0.35"
    },
    {
      "id": "nakamigos-19874",
      "name": "Nakamigos #19874",
      "image": "https://ipfs.io/ipfs/QmWuXL5rEuMxQAss1CisDTfPWoyJHgQkLhXc7tSm6g5ueu",
      "price": "1.01"
    },
    {
      "id": "nakamigos-19872",
      "name": "Nakamigos #19872",
      "image": "https://ipfs.io/ipfs/QmYpECaXmbpvLiuRVC3QecFfoMmcgXpW1ggozmBpW4Up6X",
      "price": "0.58"
    },
    {
      "id": "nakamigos-19855",
      "name": "Nakamigos #19855",
      "image": "https://ipfs.io/ipfs/QmXns85hEmWMHBGFoMyUBAFXRsAKvgv6szvAwRGXvYzGsE",
      "price": "1.17"
    },
    {
      "id": "nakamigos-19844",
      "name": "Nakamigos #19844",
      "image": "https://ipfs.io/ipfs/QmXznEh1s3Tmncd2rQCS2URpVunVro8c8BUHLdm4GMxPpP",
      "price": "0.81"
    },
    {
      "id": "nakamigos-19870",
      "name": "Nakamigos #19870",
      "image": "https://ipfs.io/ipfs/QmR3Mn9dFP4zD8YN7oLLekySoow8K9spbimo9rT9H8uWaw",
      "price": "0.37"
    },
    {
      "id": "nakamigos-19854",
      "name": "Nakamigos #19854",
      "image": "https://ipfs.io/ipfs/QmUioRkckXM89NRV5usVJfb5MMU24YTWoEUJtJqPNFA8Mt",
      "price": "1.09"
    },
    {
      "id": "nakamigos-19839",
      "name": "Nakamigos #19839",
      "image": "https://ipfs.io/ipfs/QmNxudfGUDTaCvtE1BsnVnxVK77QLiBJrACpk3T9f3rMP5",
      "price": "0.66"
    },
    {
      "id": "nakamigos-19851",
      "name": "Nakamigos #19851",
      "image": "https://ipfs.io/ipfs/QmcPYctK6HEhsHVQsHyzwMjYFeixesgBM5D9Y8kpjNTAa5",
      "price": "0.24"
    },
    
  {
    "id": "nakamigos-19866",
    "name": "Nakamigos #19866",
    "image": "https://ipfs.io/ipfs/QmbYGPzy8WG1auQ2mVx9YbnPiKvGVoP118MB1YCFLDJ1US",
    "price": "0.92"
  },
  {
    "id": "nakamigos-19838",
    "name": "Nakamigos #19838",
    "image": "https://ipfs.io/ipfs/Qmc3e1jqqLUN1foRZsLDgArskY1vZuS3bQFfbvpiWB8pdG",
    "price": "0.45"
  },
  {
    "id": "nakamigos-19837",
    "name": "Nakamigos #19837",
    "image": "https://ipfs.io/ipfs/QmPWkJvf5fqiX6hvd7qSR7er3KxqQ9MgXeRtUHe8kXTQTe",
    "price": "1.15"
  },
  {
    "id": "nakamigos-19849",
    "name": "Nakamigos #19849",
    "image": "https://ipfs.io/ipfs/QmfXob5pUdx2wz15iNxZQKDwneRzDnYNxv5L917VaEkasT",
    "price": "0.78"
  },
  {
    "id": "nakamigos-19836",
    "name": "Nakamigos #19836",
    "image": "https://ipfs.io/ipfs/QmWDkbC9Vq7kh4FxMPsFbcZyHxLiXwMbycCBcU1zfesmVm",
    "price": "0.33"
  },
  {
    "id": "nakamigos-19847",
    "name": "Nakamigos #19847",
    "image": "https://ipfs.io/ipfs/QmcaUwu3YQPKpy7DEXvKfVkkR3EzWNJ78P7GdyipK15reN",
    "price": "1.08"
  },
  {
    "id": "nakamigos-19834",
    "name": "Nakamigos #19834",
    "image": "https://ipfs.io/ipfs/QmS8b6gWVg7cPEwiL9TMFQX7zLBf1QVXeJ5cYj5t7uadqG",
    "price": "0.67"
  },
  {
    "id": "nakamigos-19831",
    "name": "Nakamigos #19831",
    "image": "https://ipfs.io/ipfs/QmaZgayxsQzkSPbEUB2q2cQDSxvpVujgWGajVFmGkGAuuo",
    "price": "0.25"
  },
  {
    "id": "nakamigos-19830",
    "name": "Nakamigos #19830",
    "image": "https://ipfs.io/ipfs/QmUiyHrgk3DYn9CkVCQRVGH1n2k7TdLTkqyjWbmCdtNfX9",
    "price": "0.95"
  },
  {
    "id": "nakamigos-19829",
    "name": "Nakamigos #19829",
    "image": "https://ipfs.io/ipfs/QmVFYScyKu7B2DLKxTtzCu28jqC3ggvuJChQmc95NTSbnr",
    "price": "0.52"
  },
  {
    "id": "nakamigos-19827",
    "name": "Nakamigos #19827",
    "image": "https://ipfs.io/ipfs/Qmd3q4ENG2mji5ZuTp2B6qi1v8EDLE6eDK3jSpdvcV1w3U",
    "price": "1.18"
  },
  {
    "id": "nakamigos-19944",
    "name": "Nakamigos #19944",
    "image": "https://ipfs.io/ipfs/QmeQEDbiBwDueAyx4SgWE6y7VJE425XShRzQ2cBh8VHRaT",
    "price": "0.83"
  },
  {
    "id": "nakamigos-19943",
    "name": "Nakamigos #19943",
    "image": "https://ipfs.io/ipfs/QmZLtdKKQ8pUb4F7Cvx4cx6dZusmKr579n42kp6BLrSJgs",
    "price": "0.41"
  },
  {
    "id": "nakamigos-19940",
    "name": "Nakamigos #19940",
    "image": "https://ipfs.io/ipfs/QmPHoQm9THbhWPxWLWuDp9Q84qv4kSjQea8sCAjrtur5Dw",
    "price": "1.12"
  },
  {
    "id": "nakamigos-19938",
    "name": "Nakamigos #19938",
    "image": "https://ipfs.io/ipfs/QmeMj1gkKd6LciPJmGWFe72mKXtZYvYaUwKRRUDDokJpS7",
    "price": "0.73"
  },
  {
    "id": "nakamigos-19937",
    "name": "Nakamigos #19937",
    "image": "https://ipfs.io/ipfs/QmPSeYm5sHnpxiHiBZhgp4Hw95byy4Fz9RE2vezvspzPfZ",
    "price": "0.29"
  },
  {
    "id": "nakamigos-19794",
    "name": "Nakamigos #19794",
    "image": "https://ipfs.io/ipfs/QmQjGqZGny5Ko5A4tzcG5ZZKc4CEyaywv26VhM8Q6tgzWf",
    "price": "1.05"
  },
  {
    "id": "nakamigos-19793",
    "name": "Nakamigos #19793",
    "image": "https://ipfs.io/ipfs/QmQEPPNE9kxqVcYY1KMmCTMKPTVcTA6vKNXd2QMxTshpJR",
    "price": "0.62"
  },
  {
    "id": "nakamigos-19790",
    "name": "Nakamigos #19790",
    "image": "https://ipfs.io/ipfs/QmazurtKihwd2SS7Y2K5JbqrDMj1Mx3sDrUdgAQRuo9C25",
    "price": "0.21"
  },
  {
    "id": "nakamigos-19884",
    "name": "Nakamigos #19884",
    "image": "https://ipfs.io/ipfs/QmSdxsSnQpUvWVwSFJCQQX3DprHVnbwKq9dsr6V1LjMjjE",
    "price": "0.88"
  },
  {
    "id": "nakamigos-19788",
    "name": "Nakamigos #19788",
    "image": "https://ipfs.io/ipfs/QmNUpxtHss8qFv8qasZS5y6f9RDguisDcHsCddhabdDrDX",
    "price": "0.49"
  },
  {
    "id": "nakamigos-19881",
    "name": "Nakamigos #19881",
    "image": "https://ipfs.io/ipfs/QmRKujyoZNks2vnFrfMQQATRb4F45etA8Esqo2LQwi57er",
    "price": "1.19"
  },
  {
    "id": "nakamigos-19895",
    "name": "Nakamigos #19895",
    "image": "https://ipfs.io/ipfs/QmdVH3r4Jx8T7BA4qzLGhXfDPfTS7uEdHiCc6GQNGUxKC4",
    "price": "0.81"
  },
  {
    "id": "nakamigos-19786",
    "name": "Nakamigos #19786",
    "image": "https://ipfs.io/ipfs/QmSggK44h6Rjt8bzZEo2iT38rhdyXqqtAupJhSWSFBibJM",
    "price": "0.37"
  },
  {
    "id": "nakamigos-19893",
    "name": "Nakamigos #19893",
    "image": "https://ipfs.io/ipfs/QmVJppVSeVt4VdjoyLCNUN95CPwsSmvdWW7QyBjeBYvixP",
    "price": "1.02"
  },
  {
    "id": "nakamigos-19878",
    "name": "Nakamigos #19878",
    "image": "https://ipfs.io/ipfs/QmeZ6MTmBpT1oiy6RezgYifZg979RfT7PPE3tb5WQ6TCVY",
    "price": "0.69"
  },
  {
    "id": "nakamigos-19877",
    "name": "Nakamigos #19877",
    "image": "https://ipfs.io/ipfs/QmYxXpcMwZYgvJ79Lvs5Qm1VZxqBZUkMBwrrZdWSZT85vS",
    "price": "0.27"
  },
  {
    "id": "nakamigos-19891",
    "name": "Nakamigos #19891",
    "image": "https://ipfs.io/ipfs/QmbapRiU6wHhm4vU63shcrioUzubu6rBM4QvfhtcFxxKzG",
    "price": "0.93"
  },
  {
    "id": "nakamigos-19876",
    "name": "Nakamigos #19876",
    "image": "https://ipfs.io/ipfs/QmWUjHoiWXNpwDWNWyQPuFcDkh121wM61SkW4mrirvSUZ9",
    "price": "0.55"
  },
  {
    "id": "nakamigos-19889",
    "name": "Nakamigos #19889",
    "image": "https://ipfs.io/ipfs/QmT3wgtJpnictC1R5jmGfxrqXxP9ZMGJT3YiK7y2T9AtxX",
    "price": "1.16"
  },
  {
    "id": "nakamigos-19865",
    "name": "Nakamigos #19865",
    "image": "https://ipfs.io/ipfs/QmUxbpw1pjzrYYAyfuGpvw9eiJg2wQSbdRmfiKhD2SCNqn",
    "price": "0.76"
  },
  {
    "id": "nakamigos-19888",
    "name": "Nakamigos #19888",
    "image": "https://ipfs.io/ipfs/Qmbn8us8rBLYkhwjDj3PBC7bDQemAjWqKVY2psop8jYgjf",
    "price": "0.34"
  },
  {
    "id": "nakamigos-19863",
    "name": "Nakamigos #19863",
    "image": "https://ipfs.io/ipfs/QmTjqErgtF1PQGSNaxbCQFjmZpspQ9WC4rxMzsq5K3RGyE",
    "price": "1.09"
  },
  {
    "id": "nakamigos-19862",
    "name": "Nakamigos #19862",
    "image": "https://ipfs.io/ipfs/QmYsVp2x3JeaBzFFRohNchrcJ1bQUA9bteQBro38qtx3Dw",
    "price": "0.64"
  },
  {
    "id": "nakamigos-19724",
    "name": "Nakamigos #19724",
    "image": "https://ipfs.io/ipfs/Qmbn5HGG3Re7woBaacZG8H2L64YSFvzbm3Lnug3Nu2dvYV",
    "price": "0.23"
  },
  {
    "id": "nakamigos-19860",
    "name": "Nakamigos #19860",
    "image": "https://ipfs.io/ipfs/QmVqsJqXRUzK3u7NXRdjX9y1VotkNFTorJTGgxwEAaCJWA",
    "price": "0.97"
  },
  {
    "id": "nakamigos-19856",
    "name": "Nakamigos #19856",
    "image": "https://ipfs.io/ipfs/QmStsxm8c1nPh6miQYNVu9sYBBPzc8GfAs3Lg7bstKoiCc",
    "price": "0.58"
  },
  {
    "id": "nakamigos-19815",
    "name": "Nakamigos #19815",
    "image": "https://ipfs.io/ipfs/Qmcn8RTrVWdRUT7SHcg1YfEUT5Xs1TxCZ7iXQhtRTwef8R",
    "price": "0.19"
  },
  {
    "id": "nakamigos-19812",
    "name": "Nakamigos #19812",
    "image": "https://ipfs.io/ipfs/QmUrSfYgTCYB4fhvB2SjpqG5Cbat7FmdpNkh2BdaTiuztM",
    "price": "0.86"
  },
  {
    "id": "nakamigos-19825",
    "name": "Nakamigos #19825",
    "image": "https://ipfs.io/ipfs/QmbPuucYqU4oS5nVLnNSFtMkLfkimM58An5LvrMogipfN8",
    "price": "0.43"
  },
  {
    "id": "nakamigos-19809",
    "name": "Nakamigos #19809",
    "image": "https://ipfs.io/ipfs/QmStMS3Y6LZDWW6b95vymv3mFzizD2JHGN8gS2gnthtcfv",
    "price": "1.11"
  },
  {
    "id": "nakamigos-19824",
    "name": "Nakamigos #19824",
    "image": "https://ipfs.io/ipfs/QmcMZ9AoNKgxFUAwRpeELDKUb4pDxAW2Y6xK23iscJ6NwT",
    "price": "0.71"
  },
  {
    "id": "nakamigos-19721",
    "name": "Nakamigos #19721",
    "image": "https://ipfs.io/ipfs/QmWQmjxqGWWh2YdgAnAc1Vbpr29hHxiry6ASNkfTRKRZ5i",
    "price": "0.31"
  },
  {
    "id": "nakamigos-19807",
    "name": "Nakamigos #19807",
    "image": "https://ipfs.io/ipfs/QmQFqYNcLcF1eZLZng4Nni75E6enKmJ51qzaS9pj57ev59",
    "price": "1.04"
  },
  {
    "id": "nakamigos-19735",
    "name": "Nakamigos #19735",
    "image": "https://ipfs.io/ipfs/QmRjpCqSv3yG6RH6r97YmfiXVt4htBYvN7iebzNYocJdT2",
    "price": "0.66"
  },
  {
    "id": "nakamigos-19822",
    "name": "Nakamigos #19822",
    "image": "https://ipfs.io/ipfs/QmRbwq5AAzMUze8gCpbJo8tdHmWPxxYrSXa2QFdMaietzx",
    "price": "0.24"
  }


    

];